export const rootKey = '_TimeSignalsTotalsState';
export const getCachedDates = (key: string | undefined): string[] => {
  key = `${key}${rootKey}`;
  const timeSignalsTotalMapRaw = sessionStorage.getItem(key);
  const timeSignalsTotalMap = JSON.parse(
    timeSignalsTotalMapRaw ? timeSignalsTotalMapRaw : '[]'
  );
  return timeSignalsTotalMap;
};

export const cacheDates = (key: string | undefined, dates: string[]): void => {
  key = `${key}${rootKey}`;
  sessionStorage.setItem(key, JSON.stringify(dates));
};

export const clearCachedDates = (key: string | undefined): void => {
  key = `${key}${rootKey}`;
  sessionStorage.removeItem(key);
};
